import React, { useState, useEffect } from "react";
import { useUserQuery } from "queries";
import {
  Alert,
  Button,
  Container,
  Card,
  CardBody,
  CardTitle,
  CardText,
  CardFooter,
} from "reactstrap"; 
import { Trans, useTranslation } from "react-i18next";
import { NotificationManager } from "react-notifications";
import BackButton from "components/refactoring/BackButton";
import store_logo from 'assets/images/integration-icon.svg';
import { Page } from "components/common";
import { XeroClient, ZatcaClient } from "services";
import LoadingMsg from "components/common/LoadingMsg";
import { useOrganisationContext } from "hooks";
import { useHistory } from "react-router-dom";
import ZatcaConfig from "./ZatcaConfig";
import { formatDate } from "services/util";


const ZatcaSDKIntegration = ({ v, history, }) => {

  const regLink = () => {
    history.push(`/zatca/registration`);
  };

  const renewLink = (id) => {
    history.push(`/zatca/renew/${id}`);
  };

  const detailsLink = (id) => {
    history.push(`/zatca/details/${id}`);
  };

  const xero = XeroClient()
  const zatca = ZatcaClient()

  const [orgs, setOrgData] = useState(null);
  const [zatcaApps, setZatcaApps] = useState([]);

  const [loading, setLoading] = useState(false);

  const fetchData = async () => {
    setLoading(true)
    try {
      var response = await xero.get("organisations");
      setOrgData(response.data);

      var response = await zatca.get("sdk");
      setZatcaApps(response.data);
      setLoading(false)
    } catch (error) {
      console.error("Error fetching data:", error);
      setLoading(false)
    }
  };

  useEffect(() => {
    fetchData();
  }, []);

  const handleDelete = (id) => {
    setLoading(true)
    zatca.delete(`sdk/${id}`)
      .then(response => {
        NotificationManager.success(response.data);
        fetchData();
        setLoading(false)
      })
      .catch(error => {
        console.error("Error:", error);
        NotificationManager.error("Error occurred while saving");
        setLoading(false)
      });
  };

  const org = orgs?.[0]

  return (
    <div>
      {loading && <LoadingMsg />}
      {!loading && zatcaApps?.map((zatcaApp) => (
        <Card key={zatcaApp.id} outline className="shadow-sm mt-3 border">
          <CardBody>
            <div className="row">
              <div className="col-2 d-flex">
                <img src={store_logo}
                  className="m-auto" alt="" width={60} />
              </div>
              <div className="col-10" style={{ borderInlineStart: "2px solid #e9ecef" }}>
                <div className="row">
                  <div className="col-8">
                    <CardTitle tag="h5">
                      <Trans>Manage your Taxes and E-Invoice through Zatca Integration</Trans>
                    </CardTitle>
                    <CardText className="mb-2 text-muted mb-0" >
                      <div>
                        <span><Trans>Renew your Onboarding for</Trans> <strong>{zatcaApp.common_name}</strong> 
                        <Trans>with RN:</Trans> <strong>{zatcaApp.registration_number}</strong>, 
                        <span className="d-block"><Trans>Type:</Trans> <strong>{zatcaApp.csr_type}</strong></span>
                        <span className="d-block"><Trans>Tax Number</Trans>: <strong>{zatcaApp.vat}</strong></span>
                        <span className="d-block"><Trans>Integration Date</Trans>: <strong>{formatDate(zatcaApp.created_at)}</strong></span>
                        </span>
                      </div>
                    </CardText>
                  </div>
                  <div className="col-4 text-right">
                    <button className="btn btn-warning" onClick={() => handleDelete(zatcaApp.id)}><Trans>Remove</Trans></button>
                    <button className="btn btn-primary" onClick={() => renewLink(zatcaApp.id)}><Trans>Renew</Trans></button>
                  </div>
                </div>
              </div>
            </div>
          </CardBody>
          <CardFooter>
            <div className="row">
              <div className="col">
                <div className="buttons-container d-flex">
                  <div className="col">
                    <Button className="ml-0" onClick={() => detailsLink(zatcaApp.id)}>
                      <Trans>Details</Trans>
                    </Button>
                  </div>
                </div>
              </div>
              <div className="col d-flex align-items-center justify-content-end">
                <div className="status text-muted">
                  <span><i className="fas fa-check mx-1" style={{ fontSize: '0.7rem' }}></i><Trans>Registered</Trans></span>
                </div>
              </div>
            </div>
          </CardFooter>
        </Card>
      ))}


      {orgs !== null &&
        <div>
          {zatcaApps.length === 0 ?
            <div className="mb-4 inv-table">
              <Card outline className="shadow-sm mt-3">
                <CardBody>
                  <div className="row">
                    <div className="col-2 d-flex">
                      <img src={store_logo}
                        className="m-auto" alt="" width={60} />
                    </div>
                    <div className="col-10" style={{ borderInlineStart: "2px solid #e9ecef" }}>
                      <div className="row">
                        <div className="col-8">
                          <CardTitle tag="h5">
                            <Trans>Manage your Zatca Integration</Trans>
                          </CardTitle>
                          <CardText className="mb-2 text-muted mb-0" style={{ height: "45px" }}>
                            <span><Trans>Connect your <strong>{org.LegalName}</strong> to Zatca and Register to benefit from Tax verification.</Trans></span>
                          </CardText>
                        </div>
                        <div className="col-4 text-right">
                          <button className="btn btn-primary" onClick={regLink}><Trans>Onboarding</Trans></button>
                        </div>
                      </div>
                    </div>
                  </div>
                </CardBody>
                <CardFooter>
                  <div className="row">
                    <div className="col">
                      <div className="buttons-container d-flex">
                      </div>
                    </div>
                    <div className="col d-flex align-items-center justify-content-end">
                      <div className="status text-muted">
                        <Trans>Not Registered</Trans>
                      </div>
                    </div>
                  </div>
                </CardFooter>
              </Card>
            </div>
            :
            <Card outline className="shadow-sm mt-3 border">
              <CardBody>
                <div className="row">
                  <div className="col-12">
                    <div className="row">
                      <div className="col-8 d-flex align-items-center">
                        <CardTitle tag="h5" className="p-0 m-0">
                          <Trans>Need more zatca Onboardings, you can do that now!</Trans>
                        </CardTitle>
                      </div>
                      <div className="col-4 text-right">
                        <button className="btn btn-primary" onClick={regLink}><Trans>New Onboarding</Trans></button>
                      </div>
                    </div>
                  </div>
                </div>
              </CardBody>
            </Card>
          }
        </div>
      }

    {zatcaApps.length > 0 && 
    <ZatcaConfig />
    }

    </div>
  );
};

function ZatcaHome() {
  const { data: user, isLoading } = useUserQuery({
    keepPreviousData: true,
  });

  const history = useHistory()

  const { selectedOrganisation } = useOrganisationContext()

  if (isLoading) return null;

  const container = (children) => (
    <Container className="mt-4">{children}</Container>
  );

  const goToCustomizeSubscriptionPage = (from) => {
    history.push({
      pathname: '/feature-subscription',
      search: `from=${from}`
    })
  }

  const isZatcaSubscribed = selectedOrganisation?.subscribed_features?.hesaabmodule?.includes('wpconnect')
  const isTrial = selectedOrganisation?.is_trial
  const isConnected = selectedOrganisation?.status === "LIVE"

  if (!isZatcaSubscribed && !isTrial) {
    return container(
      <>
        <Page title="Integration Page">
          <BackButton />
          <Alert color="warning">
            <Trans>Your subscription does not allow access to Advanced Tools.</Trans>
          </Alert>

          <div className="text-center">
            <Button size="sm" color="primary" onClick={() => goToCustomizeSubscriptionPage('wpconnect')}><Trans>Buy Now</Trans></Button>
          </div>

        </Page>
      </>
    );
  } else if (isTrial && !isZatcaSubscribed) {
    return container(
      <Alert color="warning">
        <Trans>You cannot access E-Invoicing while in Trial Period.</Trans>
      </Alert>
    );
  } else if (!isConnected) {
    return container(
      <Alert color="warning">
        <Trans>Please connect your organisation to xero to utilize E-Invoicing.</Trans>
      </Alert>
    );
  }

  return container(
    <>
      <Page title="Integration Page">
        <BackButton />
        <ZatcaSDKIntegration history={history} />
      </Page>
    </>
  );
};

export default ZatcaHome